export const STATUS_PAID = "paid";
export const STATUS_PENDING = "pending";
export const STATUS_ERROR = "error";
export const STATUS_CANCELED = "canceled";
